import { useEffect, useState } from "react"

export const useMouse = (handleSelection) => {
  const [tracking, setTracking] = useState(false)
  const [selection, setSelection] = useState({
    from: { x: 0, y: 0 },
    to: { x: 0, y: 0 },
  })

  const getCellCoords = (e) => ({
    x: parseInt(e.target.dataset.x),
    y: parseInt(e.target.dataset.y),
  })

  useEffect(() => {
    let lastHover = { x: 0, y: 0 },
      from = null

    const handleMouseMove = (e) => {
      if (e.target.classList.contains("cell")) {
        const t = getCellCoords(e)
        if (t.x === lastHover.x && t.y === lastHover.y)
          // si sigo en el mismo cuadradito, no actualizo
          return
        lastHover = t
        setSelection((current) => ({ ...current, to: lastHover }))
      }
    }

    const handleClick = (e) => {
      if (!e.target.classList.contains("cell")) {
        // reinicio todo
        from = null
        setTracking(false)
        document.removeEventListener("mousemove", handleMouseMove)
        return
      }
      // es 1er o 2do click ?
      if (!from) {
        from = getCellCoords(e)
        setTracking(true)
        setSelection({ from: from, to: from })
        document.addEventListener("mousemove", handleMouseMove)
      } else {
        setTracking(false)
        document.removeEventListener("mousemove", handleMouseMove)
        const to = getCellCoords(e)
        handleSelection({ from, to })
        from = null
      }
    }

    document.addEventListener("click", handleClick)

    return () => {
      document.removeEventListener("click", handleClick)
      document.removeEventListener("mousemove", handleMouseMove)
    }
  }, [handleSelection])

  return [tracking, selection]
}
